import {Component, Input, OnInit} from '@angular/core';
import {ProductService} from "../../../service/product.service";
import {SavedPropertyService} from "../../../service/saved-property.service";
import {SavedPropertyDocumentContainer} from "../../../model/savedPropertyDocumentContainer";
import {LoginIdService} from "../../../service/login-id.service";
import {tap} from "rxjs/operators";

@Component({
  selector: 'app-document-overview-last-order',
  templateUrl: './document-overview-last-order.component.html',
  styleUrls: ['./document-overview-last-order.component.css']
})
export class DocumentOverviewLastOrderComponent implements OnInit {

  keys: String[] = [];
  productsByCategory: Object;
  documentEntryDate = new Map();
  isLoadingEntryDates: boolean = false;
  savedPropertyDocumentContainerList: SavedPropertyDocumentContainer[] = [];
  today: Date;
  @Input() savedPropertyId: string;

  constructor(private productService: ProductService, private savedPropertiesService: SavedPropertyService, private loginIdService: LoginIdService) { }

  async ngOnInit(): Promise<void> {
      await this.loginIdService.loginServiceInitialized$.toPromise();
      this.today = new Date();
      this.isLoadingEntryDates = true;

      const savedPropertyDocuments = sessionStorage.getItem("savedPropertyDocuments")

      if (savedPropertyDocuments) {
          this.savedPropertyDocumentContainerList = JSON.parse(savedPropertyDocuments);
      }

      this.initProductCategories();

      this.getDocumentsForSavedPropertyId();
  }

    /**
     * Initializes the products categories and this.keys which represents all the categories
     */
    private initProductCategories() {
        this.productService.getProductByCategory().subscribe(productsMap => {
            this.productsByCategory = JSON.parse(JSON.stringify(productsMap));
            this.keys = Object.keys(productsMap);
        })
    }


    /**
     * Gets a map of all document names of all documents for the SavedProperty with the id this.savedPropertyId and
     * updates the savedPropertyDocumentContainerList in the sessionStorage for a specific saved property id.
     */
    private getDocumentsForSavedPropertyId(): void {
        this.savedPropertiesService.getDocumentsBySavedId(this.savedPropertyId, this.loginIdService.getCurrentCustomHeadersWithoutSpinner()).pipe(
            tap({
                next: (res) => {
                    this.documentEntryDate = new Map([[this.savedPropertyId, res]]);
                    let savedPropertyDocumentContainer: SavedPropertyDocumentContainer = new SavedPropertyDocumentContainer(this.savedPropertyId, new Map(Object.entries(res)));
                    this.savedPropertyDocumentContainerList.push(savedPropertyDocumentContainer);
                    sessionStorage.setItem("savedPropertyDocuments", JSON.stringify(this.savedPropertyDocumentContainerList));
                    this.isLoadingEntryDates = false;
                }
            })
        ).subscribe();
    }


}
